<template>
  <wrap-container>
    <help-title title="Estado de Reclamo" />

    <help-list-container>
      <help-list-item tituloLista="Banca Online">
        Ingresa en Banca Online en la opción <strong>"Mis gestiones"</strong> y
        luego en <strong>"Pedidos y reclamos"</strong>. Desde allí podrás
        iniciar, visualizar y dar seguimiento a todos tus reclamos y pedidos
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    ContactLink
  }
};
</script>
